
import { toast } from 'react-toastify'
import moment from 'moment'
import * as $ from 'jquery'
import { store } from '../../redux/store'

import { format, parse, getHours, getMinutes, startOfYesterday, subDays, eachDayOfInterval, formatDistanceToNow, differenceInDays } from 'date-fns'
import { config } from '../../helpers';
import JSZip from 'jszip'
import { saveAs } from 'file-saver'
import { ACCOUNT_MANAGER, NETWORK_MANAGER } from '../../helpers/roles'
import axios from 'axios'

const dateFormat = "YYYY-MM-DD";
const timeFormat = "HH:mm";

const datePickerDateFormat = "MM/dd/yyyy";
// eslint-disable-next-line
const datePickerTimeFormat = "HH:mm";

export const extensionLists = { video: ['m4v', 'avi', 'mpg', 'mp4', 'webm'], image: ['jpg', 'gif', 'bmp', 'png', 'jpeg', 'svg'], tc: ["pdf", "doc", "docx"], data: ["csv"] };


export const notify = (message, type) => {
    if (type === "info" || type === "i") {
        return toast.info(message)
    }
    else if (type === "success" || type === "s") {
        return toast.success(message)
    }
    else if (type === "warning" || type === "w") {
        return toast.warn(message)
    }
    else if (type === "error" || type === "e") {
        return toast.error(message)
    }
    else {
        return toast(message)
    }

}

export const notifyError = (message) => {
    notify(message || "Oops something went wrong! Please try again!", "e")
}

export const secondstoMH = (totalSeconds) => {
    const days = Math.floor(totalSeconds / (24 * 3600));
    totalSeconds %= (24 * 3600);
    
    const hours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return `${String(days).padStart(2, '0')}:${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    // let formatTime = "00:00:00:00"
    // if (seconds) {
    //     seconds = Number(seconds);
    //     let date = new Date(null);
    //     date.setMinutes(0);
    //     date.setHours(0);
    //     date.setDate(1)
    //     date.setSeconds(seconds);
    //     let s = date.getSeconds();
    //     let m = date.getMinutes();
    //     let h = date.getHours();
    //     let d = date.getDate()

    //     formatTime = `${d - 1 < 10 ? "0" : ""}${d - 1}:${h < 10 ? "0" : ""}${h}:${m < 10 ? "0" : ""}${m}:${s < 10 ? "0" : ""}${s}`
    // }
    // return formatTime;
}

export const numberWithCommas = (x) => {
    if (x) {
        var parts = x.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
    }
    return x;
}

export const removeThousandSeparator = (x) => {
    if (x) {
        return x.replace(/,/gi, "");
    }
    return x;
}
export const getRangeString = (value) => {
    const { min, max } = value;
    if(min && max) return min === max ? min : `${min} - ${max}`;
    return null
}
export const getQueryStringParams = query => {
    return query
        ? (/^[?#]/.test(query) ? query.slice(1) : query)
            .split('&')
            .reduce((params, param) => {
                let [key, value] = param.split('=');
                params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
                return params;
            }, {}
            )
        : {}
};

export const stringDate = (date) => {
    return moment(date).format(dateFormat);
}

export const dateNow = () => {
    return moment().format(dateFormat + " " + timeFormat);
}

export const minDate = (datea, dateb) => {
    return moment.min(moment(datea), moment(dateb)).format(dateFormat);
}

export const stringTime = (time) => {
    return moment(time).format(timeFormat);
}

export const calculateTotalPageNumber = (totalRows, limitPerPage) => {
    return Math.ceil(totalRows / limitPerPage)
}

export const calculateOffset = (limitPerPage, pageNum) => {
    return (limitPerPage * (pageNum - 1))
}
export const getDemoURL = ad => {
    let url = config.previewServer + "c/" + ad._id;

    if (ad && ad.scripts && ad.scripts.widespaceSid) {
        url = config.previewServer + "demo/" + ad.scripts.widespaceSid + "?width=" + ad.width + "&height=" + ad.height + "&format=" + ad.format || ad.ad_type;
    }
    if(ad.device === "1") url += "?desktop=true&focusAd=true" + (ad.width > 320 ? "&pos=top" : "")
    else url += (ad.scripts && ad.scripts.widespaceSid ? "&focusAd=true" : ad.scripts && ad.scripts.secureScript ? "?focusAd=true&tagReady=true" : "?focusAd=true")

    return url
}
export const getLabelFromValue = (opts, val) => {
    // eslint-disable-next-line
    var filter = opts.filter(o => val == (o.value));
    if (filter.length > 0) {
        if (filter[0].label) {
            return filter[0].label;
        }
        else {
            return "";
        }
    }
    return "";
};

export const getValueFromLabel = (opts, val) => {
    // eslint-disable-next-line
    var filter = opts.filter(o => val == (o.label));
    if (filter.length > 0) {
        return filter[0];
    }
    else {
        return [];
    }
};

export const getFormatTypeLabel = (option) => `${option.countryName} - ${option.name} - ${option.currencyCode} ${option.priceFloor} - ${option.accountName}`
export const getFormatTypeLabelFilter = (option) => `${option.name} - ${option.currencyCode} ${option.priceFloor} - ${option.accountName}`

export const getValueFromObject = (opts, val, objectname) => {
    // eslint-disable-next-line
    var filter = opts.filter(o => val == o[objectname]);
    if (filter.length > 0) {
        return filter[0];
    }
    else {
        return [];
    }
};
export const countCarbonReduction = (data) => {
    let totalPercentage = 0
    if ((data?.carbon_reduction > 0 || data?.carbon_reduction < 0) && (data?.pre_decarbonisation > 0 || data?.pre_decarbonisation < 0)) totalPercentage = ((data.carbon_reduction / data.pre_decarbonisation) * 100).toFixed(1)
    return totalPercentage
}
export const getAllValuesFromObject = (opts, val, objectname) => {

    if (val && opts) {
        let valArr = val.split(",");
        let filter = [];
        for (let i = 0; i < valArr.length; i++) {
            filter.push(getValueFromObject(opts, valArr[i], objectname));
        }
        // eslint-disable-next-line
        //var filter = opts.filter(o => val == o[objectname]);
        if (filter.length > 0) {
            return filter;
        }
        else {
            return [];
        }
    }
    else {
        return [];
    }

};
export const handleMultipleValues = (values, options, name, fieldName = "id") => {
    if (values && values[name] && !(values[name] instanceof Array) && options && options.data) {
        let selectedArr = "";
        selectedArr = values[name].split(",");
        let selectedObject = [];

        for (let i = 0; i < selectedArr.length; i++) {
            selectedObject.push(getValueFromObject(options.data, selectedArr[i], fieldName));
        }
        return selectedObject;
    }
    return values[name]
}
export const forceDownload = (data, name = "report.xlsx") => {
    let url = window.URL.createObjectURL(new Blob([data]));
    let link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', name);
    document.body.appendChild(link);
    link.click();
    link.remove()
}
export const forceDownloadLink = (href) => {
    const link = document.createElement('a');
    link.href = href;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
export const convertUTCTime = (date) => {
    var user = store.getState().user
    let timeZone = user.timeZone || "Australia/Sydney"
    const localDate = new Date(date.replace(/-/g, "/") + " UTC")
    return new Date(localDate.toLocaleString('en-US', { timeZone: timeZone }))
}
export const convertTime = date => {
    var user = store.getState().user
    let timeZone = user.timeZone || "Australia/Sydney"
    
    const localDate = new Date(date.replace(" ", "T") + "Z"); // Convert "2025-01-09T03:08:03.006236Z" to new date

    return new Date(localDate.toLocaleString('en-US', { timeZone, hour12: false, timeZoneName: 'short' }));
}
export const formatTime = (secs = 0) => {
    let seconds = secs;

    const days = Math.floor(seconds / 86400); // Calculate days (1 day = 86400 seconds)
    seconds %= 86400;

    const hours = Math.floor(seconds / 3600); // Calculate remaining hours
    seconds %= 3600;

    const minutes = Math.floor(seconds / 60); // Calculate remaining minutes
    const remainingSeconds = seconds % 60; // Remaining seconds

    let result = '';
    if (days > 0) result += `${days}d `;
    if (hours > 0) result += `${hours}h `;
    if (minutes > 0) result += `${minutes}m `;
    result += `${remainingSeconds}s`; 

    return result.trim(); 
};
export const downloadCSVFromString = (csvData, csvTitle = "Report") => {
    var blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });

    var link = document.createElement("a");
    if (link.download !== undefined) { // Feature detection
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", `${csvTitle}.csv`);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } else {
        alert("Browser does not support downloading files. Please try a different browser.");
    }
}

export const downloadCSVFromArray = (rows = [], csvTitle = "Report") => {
    const csvData = rows
      .map(row => row.split(",").map(cell => `"${cell}"`).join(","))
      .join("\n");

    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });

    const link = document.createElement("a");
    if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", `${csvTitle}.csv`);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } else {
        alert("Browser does not support downloading files. Please try a different browser.");
    }
};


export const downloadCSV = (JSONData, csvTitle = "Report", showLabel = true) => {
    //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
    var arrData = typeof JSONData !== "object" ? JSON.parse(JSONData) : JSONData;

    var CSV = "";

    if (showLabel) {
        let rowLabel = "";
        //This loop will extract the label from 1st index of on array
        for (var indexLabel in arrData[0]) {
            rowLabel += indexLabel + ",";
        }
        rowLabel = rowLabel.slice(0, -1);
        CSV += rowLabel + "\r\n";
    }

    //to extract each row
    for (var i = 0; i < arrData.length; i++) {
        let row = "";
        //loop to extract each column and convert it in string comma-seprated
        for (var index in arrData[i]) {
            row += '"' + arrData[i][index] + '",';
        }
        row.slice(0, row.length - 1);
        CSV += row + "\r\n";
    }

    if (CSV === "") {
        alert("Invalid data");
        return;
    }

    var fileName = csvTitle.replace(/ /g, "_");
    var uri = "data:text/csv;charset=utf-8," + escape(CSV);

    //this trick will generate a hidden temp <a /> tag
    var link = document.createElement("a");
    link.href = uri;
    link.style = "visibility:hidden";
    link.download = fileName + ".csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
export const CSVToJSON = async (values) => {
    if (values) {
        if (values.size < 500000) {
            if (extensionLists["data"].indexOf(values.name.split('.').pop()) > -1) {
                const filePromises = await new Promise((resolve, reject) => {
                    try {
                        var file = values;
                        var reader = new FileReader();
                        reader.readAsText(file);
                        reader.onload = async (event) => {
                            var result = [];
                            var csv = event.target.result.replaceAll(";", ",");
                            var lines = csv.split("\n");
                            var headers;
                            headers = lines[0].split(",");

                            for (var i = 1; i < lines.length; i++) {
                                var obj = {};

                                if (lines[i] === undefined || lines[i].trim() === "") {
                                    continue;
                                }

                                var words = lines[i].split(",");
                                for (var j = 0; j < words.length; j++) {
                                    if (headers[j]) obj[headers[j].trim()] = words[j].replace(/(\r\n|\n|\r)/gm, "");
                                }
                                result.push(obj);
                            }

                            resolve(JSON.stringify(result))
                        }
                    } catch (err) { reject(err) }
                })
                await Promise.all(filePromises);

                return filePromises
            }
            else notify("Wrong format please upload csv", "e")
        }
        else notify("Max Size 500kb", "e")
    }
    else return ""
}
export const addClass = (el, className) => {
    if (el.classList)
        el.classList.add(className);
    else
        el.className += ' ' + className;
}

export const removeClass = (el, className) => {
    $("." + el).removeClass(className);

    /* if (el.classList)
        el.classList.remove(className);
    else
        el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' '); */
}

export const toInputPickerType = (values) => {
    // eslint-disable-next-line
    if (values == undefined || values.data == undefined || values.length == 0) return [];
    return values && values.data && values.data.map((item) => ({
        "label": item.name,
        "value": item.id,
    }))
}
export const toDateSentence = (date) => {
    if (date) {
        return formatDistanceToNow(convertUTCTime(date.replace("+00", "")), { addSuffix: true })
    }
    return ""
} 


export const saveStringTextsToZip = (values, title) => {
    let zip = new JSZip()
    if (values?.length > 0) {
        values.forEach((value) => {
            //important note: title must be unique or it will replace existing file
            zip.file(`${value.title?.replace(/[&/\\#,+()$~%.'":*?<>{}!|]/g, '_')}.txt`, value.content);
        })
        zip.generateAsync({ type: "blob" }).then((content) => {
            saveAs(content, title + ".zip");
        });
    }
}
export const toFormData = (object) => {
    const formData = new FormData();
    Object.keys(object).forEach(key => formData.append(key, (object[key] === null ? "" : typeof object[key] === "string" ? object[key].trim() : object[key])));
    return formData;
}

export const getFilename = (path) => {
    return path.substring(path.lastIndexOf('/') + 1);
}

export const getFileSize = (path) => {
    var img = new Image();
    img.onload = function () {
        return this.width + 'x' + this.height;
    }
    img.src = path;
}

const COUNT_ABBRS = ['', 'K', 'M', 'B', 'T', 'Q', 'P', 'E', 'Z', 'Y'];

export const shortFormNumber = (count, withAbbr = true, decimals = 2) => {
    //count = (count.replace(/,/g, ""));
    const absCount = Math.abs(count);
    const i = absCount === 0 ? 0 : Math.floor(Math.log(absCount) / Math.log(1000));
    let result = parseFloat((absCount / Math.pow(1000, i)).toFixed(decimals));
    if (withAbbr) {
        result += `${COUNT_ABBRS[i]}`;
    }
    
    return count < 0 ? `-${result}` : result;
}
export const shortFormEmissionNumber = (count) => {
    if (count < 1) return count
    return (shortFormNumber(count))
}
export const shortFormBytes = (bytes) => {
    const kilobyte = 1024, megabyte = kilobyte * 1024;

    if (!bytes) return 0

    if (bytes < kilobyte) return bytes + 'B';
    else if (bytes < megabyte) return Math.round(bytes / kilobyte) + 'KB';
    else return Math.round(bytes / megabyte) + 'MB';
}
export const loadDefaultThumbnail = (e, isShowcase = false) => {
    e.target.src = isShowcase ? "/images/showcase-default-card.jpg" : "/images/default_deal_card.png";
}
export const roundToDecimal = (value, decimal = 1) => {
    let roundVal = Math.pow(10, decimal)
    return Math.round(value  * roundVal) / roundVal
}

export const getCommaSeparated = (object, valueOf) => {
    return object.map((o) => {
        return o[valueOf];
    }).join(",");
}
export const getFormatTier = (text) => text.replace(/(,\s*daily test\s*,?|daily test\s*,?)/gi, '').replace(/\s{2,}/g, ' ').trim()
/* Date FNS */

export const parseStringToDate = (dateString) => {
    return parse(dateString, datePickerDateFormat, new Date());
}

export const getHoursFromDate = (date) => {
    return ("0" + getHours(date)).slice(-2);
}

export const getMinutesFromDate = (date) => {
    return ("0" + getMinutes(date)).slice(-2);
}

export const yesterday = () => {
    return format(startOfYesterday(), 'd MMMM yyyy');
}

export const getFutureDays = (date, day) => {
    let dateToReturn = new Date(date);
    dateToReturn.setDate(dateToReturn.getDate() + Number(day));
    return  format(dateToReturn, 'yyyy-MM-dd')
}
export const getOldDays = (n, isFormatRequired = false) => {
    let dateToReturn = subDays(new Date(), n);
    return isFormatRequired ? format(dateToReturn, 'd MMMM yyyy') : dateToReturn;
}
export const dayDistance = (date, newDate) => {
    return differenceInDays(new Date(newDate), new Date(date))
}
export const getOldMonths = (months) => {
    let previouseMonth = new Date()
    previouseMonth.setMonth(new Date().getMonth() - months);
    return previouseMonth
}

export const formatReportDate = (date) => {
    return format(new Date(date), 'd MMMM yyyy');
}

export const getHeaderName = (date) => {
    return format(new Date(date), 'MM/dd');
}

export const getDayName = (date) => {
    return format(new Date(date), 'EEEE');
}
export const getDateNumber = (date) => {
    return format(new Date(date), 'do');
}
export const getMonthName = (date) => {
    return format(new Date(date), 'LLLL');
}
export const getBegginingOfMonth = () => {
    let date = new Date(), y = date.getFullYear(), m = date.getMonth();
    return new Date(y, m, 1);
}

export const getDiffInHours = (start, end) => {
    let timeStart = new Date("01/01/2007 " + start).getHours();
    let timeEnd = new Date("01/01/2007 " + end).getHours();

    return (timeEnd - timeStart);
}

export const getDatesBetween = (startDate, endDate) => {
    let result = eachDayOfInterval({ start: new Date(startDate), end: new Date(endDate) });
    if (result && result.length) {
        let formattedResult = [];
        result.forEach(d => {
            formattedResult.push(format(d, "yyyy-MM-dd"))
        })
        return formattedResult;
    }
    return result
}
/* Getting a object searching deeply */
export const getObjectDeep = (theObject, key, keyValue, result) => {
    var i,
        proto = Object.prototype,
        ts = proto.toString,
        hasOwn = proto.hasOwnProperty.bind(theObject);

    if ('[object Array]' !== ts.call(result)) result = [];

    for (i in theObject) {
        if (hasOwn(i)) {
            if (i === key) {
                // eslint-disable-next-line
                if (theObject[i] == keyValue) {
                    result.push(theObject);
                }
            } else if ('[object Array]' === ts.call(theObject[i]) || '[object Object]' === ts.call(theObject[i])) {
                getObjectDeep(theObject[i], key, keyValue, result);
            }
        }
    }

    return result;

}


/* React date range date format */
export const formatDateDisplay = (date, defaultText) => {
    if (!date) return defaultText;
    return format(new Date(date), 'yyyy-MM-dd');
}
export const formatDateDisplayYearMonth = (date, defaultText) => {
    if (!date) return defaultText;
    return format(new Date(date), 'yyyy-MM');
}


/* React date range date format */
export const formatDateMonthDisplay = (date, defaultText) => {
    if (!date) return defaultText;
    return format(new Date(date), 'd MMM, yyyy');
}

export const getSrcExtension = (src) => {
    if (src.includes('?')) {
        src = src.slice(0, src.indexOf('?'));
    }
    return src.split('.').pop();
}

/* Get timezone offset */
export const getTimezoneOffset = () => {
    var date = new Date();
    var tz = date.getTimezoneOffset();
    return (tz / 60);
}

export const sec2time = (timeInSeconds) => {
    if (timeInSeconds) {
        var pad = function (num, size) { return ('000' + num).slice(size * -1); },
            time = parseFloat(timeInSeconds).toFixed(3),
            hours = Math.floor(time / 60 / 60),
            minutes = Math.floor(time / 60) % 60,
            seconds = Math.floor(time - minutes * 60)
        return pad(hours, 2) + ':' + pad(minutes, 2) + ':' + pad(seconds, 2);
    }
    else {
        return;
    }
}


export const getWithOrdinalSuffix = (i) => {
    var j = i % 10,
        k = i % 100;
    // eslint-disable-next-line
    if (j == 1 && k != 11) {
        return i + "st";
    }
    // eslint-disable-next-line
    if (j == 2 && k != 12) {
        return i + "nd";
    }
    // eslint-disable-next-line
    if (j == 3 && k != 13) {
        return i + "rd";
    }
    return i + "th";
}


/* For curated Medias */

export const isDealInfoAvail = (ad) => {
    return ad && ad["page-info"] && ad["page-info"].length;
}

export const isCreativeAvail = (ad) => {
    return ad && ad["creative"] && ad["creative"].length && ad["creative"] !== "null";
}

export const isBriefAvail = (ad) => {
    return ad && ad["briefs"] && ad["briefs"].length && ad["briefs"] !== "null";
}

export const isMediaAvail = (ad) => {
    return ad && ad["curated-media"] && ad["curated-media"].length && ad["curated-media"] !== "null";
}
export const isDealRestricted = (deal, { role, accounts, networks }) => {
    if (deal.id === config.DEMO_DEAL_CO2_ID || deal.id === config.DEMO_DEAL_ID || deal.id === config.DEMO_DEAL_DOOH_ID) return false
    return ((role === ACCOUNT_MANAGER && accounts !== deal.accountId) || (role === NETWORK_MANAGER && networks !== deal.networkId)) ? true : false
}
export const getCampaignDates = value => {
    let date = value ? JSON.parse(value) : null
    return date?.start ? `${formatDateDisplay(new Date(date.start))} to ${formatDateDisplay(new Date(date.end))}` : "-"
}
export const getEstimatedBudget = (budget, currencyCode) => budget ? `${currencyCode} ${numberWithCommas(budget)}` : "-"
export const getDealInfo = (ad) => {
    if (isDealInfoAvail(ad)) {
        return ad["page-info"][0];
    }
    return "";
}
export const getDealPrice = (dealInfo) => {
    return Number(dealInfo.cpm ? dealInfo.cpm : (dealInfo["dealTypeInfo"]["priceFloor"] || 0))
}

export const getAddonInfo = (ad) => {
    if (ad && ad["addons"] && ad["addons"].length) {
        return ad["addons"];
    }
    return "";
}

export const getAddOnArc = (addons) => {
    let arcAddon = addons?.length ? addons.filter(x => x.subtype && x.subtype === "Attention Metrics" && x.name.toLowerCase() === "ai alpha") : [];
    let sortedAddons = [...arcAddon]
    if (sortedAddons && sortedAddons.length) {
        return sortedAddons[0];
    }
    return "";
}

export const getAddonsPrice = (addons, model = "Fixed", isPG = false) => {
    let price = 0;
    if (addons?.length) {
        let sortedAddons = [...addons]
        price = sortedAddons.map(item => model === "Fixed" ? isPG && item.name.toLowerCase() === "al alpha" ? 0 : item.bundled_discount ? Number(item.price) - Number(item.bundled_discount) : Number(item.price) : model === "Production" && item.fee ? getTotalAddonPrice(item) : 0).reduce((prev, next) => prev + next);
    }
    return price;
}


export const getAddonPriceLabel = (addon) => {
    if (addon.price_model === "Production") {
        return "Production cost"
    } else {
        return "Price CPM"
    }
}

export const getTotalAddonPrice = (d) => {
    let fees = d.fee ? JSON.parse(d.fee) : []
    let sum = 0;
    fees.forEach(element => {
        sum += Number(element.total);
    });
    return sum;
}
export const getAddonSuplyIds = (creatives, object = false) => {
    let supplyIds = []
    if (creatives && creatives.length) {
        for (let i = 0; i < creatives.length; i++) {
            let cr = creatives[i]
            if (cr && cr._id) {
                if (object) {
                    supplyIds.push({ "supply": cr._id, "name": cr.ad_name })
                } else {
                    supplyIds.push(cr._id)
                }

            }
        }
    }
    if (object) {
        return supplyIds;
    }
    else {
        return supplyIds.join(',');
    }

}
export const getAddonVendor = (addons) => {
    let vendorName = "", lumen = false, isAmplified = false
    for (let i = 0; i < addons.length; i++) {        
        if (addons[i].name.toLowerCase().includes("attention") || addons[i].name.toLowerCase().includes("ai alpha")) {
            lumen = addons[i].vendorName.toLowerCase() === "lumen"
            isAmplified = addons[i].vendorName.toLowerCase() === "amplified intelligence"
            if(lumen || isAmplified) vendorName = addons[i].vendorName.toLowerCase()
        }
    }
    return {lumen, isAmplified, vendorName}
}
export const isLumenOpt = (addons) => {
    let hasLumen = false
    for (let i = 0; i < addons.length; i++) {        
        if (addons[i].vendorName.toLowerCase() === "lumen" && (addons[i].name.toLowerCase().includes("attention") || addons[i].name.toLowerCase().includes("ai alpha"))) {
            hasLumen = true
        }
    }
    return hasLumen
}
export const isAmplifiedOpt = (addons) => {
    let hasAmplified = false
    for (let i = 0; i < addons.length; i++) {        
        if (addons[i].vendorName.toLowerCase() === "amplified intelligence" && (addons[i].name.toLowerCase().includes("attention") || addons[i].name.toLowerCase().includes("ai alpha"))) {
            hasAmplified = true
            break;
        }
    }
    return hasAmplified
}


export const getLuemnCreativeIds = (creatives, object = false) => {
    let creativeIds = []
    if (creatives && creatives.length) {
        for (let i = 0; i < creatives.length; i++) {
            let cr = creatives[i]
            if (object) {
                creativeIds.push({ "id": cr?.lamp?.supplyId || cr._id, "name": cr.ad_name })
            } else {
                creativeIds.push(cr?.lamp?.supplyId || cr._id)
            }
        }
    }
    if (object) {
        return creativeIds;
    }
    else {
        return creativeIds.join(',');
    }

}

export const isProSkinFormat = (dealType, name = "dealTypeFormatName") => {
    return (dealType && dealType[name] && dealType[name].trim().toLowerCase().includes("skin")) || false;
}

export const hasNoAddon = (name) => {
    return (name && name.trim().toLowerCase().includes("scrollo")) || (name && name.trim().toLowerCase().includes("pro-scroll")) || false;
}

export const getFormatTypeDevice = (dealType, name = "device") => {
    let device = false
    if (dealType && dealType[name]) {
        let deviceArray = dealType[name].split(',')
        if (deviceArray.length === 1) {
            device = deviceArray[0]
        }
    }
    return device;
}

export const getKritikosValue = (value, dealTypeInfo) => {
    if(!dealTypeInfo?.kritikos || !('kritikos_score' in value) || value?.kritikos_score === 0) return null
    else if(typeof value.kritikos_score === "number"){
        const { kot } = value
        return `${kot.min} - ${kot.max}`
    }
    else if(value?.kritikos_score?.toLowerCase().includes("calculating")) return "calculating"
    else return "error"
}
export const getDealTokens = (ad) => {
    return Array.prototype.map.call(ad, function (item) { return item.token; }).join(",");
}
export const getCreativeInfo = (ad) => {
    if (isCreativeAvail(ad)) {
        return ad["creative"];
    }
    return "";
}
export const getMediaInfo = (ad) => {
    if (isMediaAvail(ad)) {
        return ad["curated-media"];
    }
    return "";
}
export const getBriefInfo = (ad) => {
    if (isBriefAvail(ad)) {
        return ad["briefs"];
    }
    return "";
}

export const getDSPSlugName = (ad) => {
    return ad && ad.slug_name;
}

export const getDSPName = (ad) => {
    return ad && ad.dsp;
}

export const getDSPMacros = (ad) => {
    return ad && ad.macros;
}

export const getTier = (medias) => {

    let tierSet = new Set()
    let tier = false;
    for (let i = 0; i < medias.length; i++) {
        tierSet.add(medias[i].tier)
    }

    let tierArray = [...tierSet]

    if (tierArray.length === 1) {
        tier = tierArray[0]
    }

    return tier;
}

export const isAdvancedTier = (tier) => {
    if (tier && tier.toLowerCase() === "advanced") {
        return true;
    }
    else {
        return false;
    }
}

export const isMobileApp = (m) => {
    if (m && m.toLowerCase() === "mobile app") {
        return true;
    }
    else {
        return false;
    }
}

export const isMobileWebOnly = (m) => {
    if (m && m.toLowerCase() === "mobile web") {
        return true;
    }
    else {
        return false;
    }
}


export const isVerticalStr = (isVertical) => {
    if (isVertical) {
        return "vertical";
    }
    else {
        return "horizontal";
    }
}

export const isVerticalBol = (isVertical) => {
    if (isVertical === "vertical") {
        return true;
    }
    else {
        return false;
    }
}

export const getSwipeIcon = (isVertical) => {
    if (isVertical === "vertical") {
        return "https://s3-ap-southeast-2.amazonaws.com/library.bigbuddy.io/templates/images/swipe/swipe_vertical.png";
    }
    else {
        return "https://s3-ap-southeast-2.amazonaws.com/library.bigbuddy.io/templates/images/swipe/swipe.png";
    }
}


export const getSwipeIconCustom = (isVertical, dimension, value, isDesktop = false) => {
    var icon = "https://s3-ap-southeast-2.amazonaws.com/library.bigbuddy.io/templates/swipe_icons"
    icon += `/${dimension}/swipe_icon_${isDesktop ? "d" : "m"}_${isVertical ? "v" : "h"}_${value}.png`
    return icon;
}

export const isDealForMobileApp = (ad) => {
    if (isDealInfoAvail(ad)) {
        return ad["page-info"][0].is_mobile_app;
    }
    return "";
}

export const getExtCampaignId = (ad) => {
    if (isDealInfoAvail(ad)) {
        return ad["page-info"][0].ext_campaign_id_n;
    }
    return "";
}
export const groupBy = (arr, property) => {
    return arr.reduce(function (memo, x) {
        if (!memo[x[property]]) { memo[x[property]] = []; }
        memo[x[property]].push(x);
        return memo;
    }, {});
}

export const getTierLabel = (str) => {
    if (str === "Basic") {
        return "Premium";
    }
    else {
        return str;
    }
}

export const isSkin = (formatName) => {
    if (formatName && formatName.toLowerCase().includes("skin")) {
        return true;
    }
    return false;
}

export const isRTPT = (adInfo) => {
    if (adInfo && adInfo.dealType === "RTPT") {
        return true;
    }
    return false;
}

export const getEmissionDefault = () => 3500

export const getEmissionString = (str = "", noText = false) =>{
    const [a, b] = str.split('-').map(Number);
    if(noText) return <>{a/1000}-{b/1000}</>
    return <>{a/1000}-{b/1000}g CO<sub>2</sub> per impression</>;
}

export const getEmissionsSplit = (val, short = false) => {
    let value = (val || 0)/1000
    return <>{value}g CO<sub>2</sub> per {short ? "imp." : "impression"}</>
}

export const getEmissionsRange = (isInstream = false) => isInstream ? {min: 2500, max: 3500} : {min: 1000, max: 1500}

export const objectsToString = (e, fieldName = "id", join = ",") => {
    return e.map(a => a[fieldName]).join(join);
}
export const getStringValuesToObject = (values, arrData, fieldName = "id") => {
    let object = [];
    if (values && !(values instanceof Array)
        && arrData && arrData && arrData.length) {
        let arr = values.split(",");
        for (let i = 0; i < arr.length; i++) {
            let result = getValueFromObject(arrData, arr[i], fieldName)
            if (Object.keys(result).length !== 0) object.push(result);
        }
    }
    return object;
}
export const wrapLabel = (value, maxLength = 15) => {
  if (!value) return '';
  // Break text into chunks of maxLength
  return value.match(new RegExp('.{1,' + maxLength + '}', 'g')).join('\n');
}
export const getValueLabelsFromObjects = (values, arrData, fieldName = "id", labelName = "name") => {
    let object = [];
    if (values && !(values instanceof Array)
        && arrData && arrData.length > 1) {
        let arr = values.split(",");
        for (let i = 0; i < arr.length; i++) {
            object.push(getValueFromObject(arrData, arr[i], fieldName)[labelName]);
        }
    }
    return object.join().replace(/,(?=[^\s])/g, ", ");
}
export const getAudiencePrefix = (adInfo) => {
    if (adInfo && (adInfo.dealType === "CCM" || adInfo.dealType === "")) {
        return "Contextually Curated Media";
    }
    else if (adInfo && adInfo.dealType === "BAT") {
        return "Behavioural Audiences"
    }
    return "";

}

export const isDemoAccount = (adInfo) => {
    return adInfo && adInfo.isDemo;
}


export const isExportMethodCalled = (mediaInfo) => {
    if (mediaInfo && mediaInfo.length) {
        return mediaInfo[0].export_status;
    }

    return false;
}

export const isMobile = () => {
    let m = false;
    // eslint-disable-next-line
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
        m = true;
    }
    return m;
}

export const isScrolloDesktop = (isMobile, name) => {
    if (!isMobile && name && name.toLowerCase().indexOf("scrollo") > -1) {
        return true;
    } else {
        return false;
    }
}

export const isInterstitial = (format_type) => {
    if (format_type && format_type.toLowerCase().includes("interstitial")) {
        return true;
    }
    return false;
}

export const isNexdScript = (script) => {
    return (/data-adc-id/igm).test(script);
}
export const isAirtoryScript = (script) => {
    return (/id="ad(.*?)(\/placement)/igm).test(script);
}
export const isPrimoScript = (script) => {
    return (/src="(.*?)visarity\.com(.*?)primo\.js/igm).test(script) || (/src="(.*?)primoadserver\.com(.*?)primo\.js/igm).test(script);
}
export const getAdServerUsingScript = (script) => {
    if (isNexdScript(script)) {
        return "nexd";
    }
    else if (isAirtoryScript(script)) {
        return "airtory";
    }
    else if (isPrimoScript(script)) {
        return "primo";
    }
    return "";
}

export const clearCache = () => {
    if ('caches' in window) {
        // Service worker cache should be cleared with caches.delete()
        caches.keys().then(names => {
            // eslint-disable-next-line no-restricted-syntax
            for (const name of names) caches.delete(name);
        });
    }
    window.location.reload()
}

export const getNumberofSites = (ts, carbon = "") => {
    let sites = ts && JSON.parse(ts.trim().replace(/(\r\n|\n|\r)/gm, ""))
    if (sites && sites.length) {
        //if (carbon) sites = sites.filter(s => s.em <= carbon)
        //const unique = [...new Set(sites.map(item => item.domain))];
        //return unique.length

        const uniqueDomains = new Set();

        for (const { domain, em } of sites) {
            if (carbon && em > carbon) continue;
            uniqueDomains.add(domain);
        }

        return uniqueDomains.size;
    } else {
        return 0;
    }

}
export const setBuddySettings = (name, value) => {
    let storageValue = JSON.parse(localStorage.getItem(config.bbSettings)) || {}
    storageValue[name] = value;
    localStorage.setItem(config.bbSettings, JSON.stringify(storageValue))
}

export const getBuddySettings = (name) => {
    let storageValue = JSON.parse(localStorage.getItem(config.bbSettings))
    return storageValue ? storageValue[name] : ""
}
export const getLocalStorage = (key) => {
    const data = localStorage.getItem(key)
    return data ? JSON.parse(data) : null
}
export const saveLocalStorage = (key, values = "") => {
    localStorage.setItem(key, values ? JSON.stringify(values) : "")
}
export const findIndexOfNonEmptyArray = (array) => {
    if(array && Array.isArray(array) && array.length > 0){
        let index = array.findIndex(subArray => subArray.some(item => Object.keys(item).length > 0));
        if(index) return index
    }
    return 0
}
export const isPerformanceOpen = (user) => {
    let isRestricted = (user.role === ACCOUNT_MANAGER || user.role === NETWORK_MANAGER)
    return (!isRestricted || ((isRestricted) && user?.performance_subscribed))
}
export const checkIfFormatTypeAvail = (ad) => ad?.format_type || ad?.dealTypeInfo
export const getMediaTypes = (medias) => {
    if (medias && medias.length) {
        return Array.from(new Set(medias.map(item => item.type))).toString()
    }
    return ""
}

export const camelCaseToTitleCase = (w) => {
    const result = w.replace(/([A-Z])/g, " $1");
    return result.charAt(0).toUpperCase() + result.slice(1);
}

export const getWidthFromDimension = (d) => {
    return d && d.split("x")[0];
}

export const getHeightFromDimension = (d) => {
    return d && d.split("x")[1];
}

export const getAspectRatioWidth = (aw, ah, h) => {
    return parseFloat((h * (aw / ah)).toFixed(0));
}

export const getAspectRatioHeight = (aw, ah, w) => {
    return parseFloat((w / (aw / ah)).toFixed(0));
}
export const hasMedias = (dealDataState) => {
    return (dealDataState && (dealDataState.selectedMedias || dealDataState.use_existing_token))
}
export const equalsIgnoreOrder = (a, b) => {
    if (a.length !== b.length) return false;
    const uniqueValues = new Set([...a, ...b]);
    for (const v of uniqueValues) {
        const aCount = a.filter(e => e === v).length;
        const bCount = b.filter(e => e === v).length;
        if (aCount !== bCount) return false;
    }
    return true;
}

export const getOffsetVolume = (budget, project) => Math.trunc(Number((budget / project?.credits?.pricePerItem?.amount))* 10) / 10;

export const getSupplyPlatform = (platform, token, internalNotes = "") => {
    if (platform && isCriteo(platform)) {
        let tokenArr = token.split("-");
        let tokenId = tokenArr.length === 2 ? tokenArr[1] : ""
        return { label: "Criteo", urlDeal: `${config.supplyPlatformDeal}${tokenId}` };
    }
    else if (platform && isOutmoove(platform)) {
        let tokenArr = internalNotes?.split("-");        
        if(tokenArr?.length === 2) 
            return { label: platform, urlDeal: `${config.outmooveProposalURL(tokenArr[0], tokenArr[1])}` }
        return { label: platform, url: ""}
    }
    else if (platform){
        return { label: platform, url: "" };
    }
     else {
        return { label: "Magnite", url: "" };
    }
}
export const isCriteo = platform => {
    return platform.includes("Mediagrid") || platform.includes("Criteo")
}

export const isOutmoove = platform => {
    return platform.includes("Outmoove") || platform.includes("outmoove")
}

export const isGridError = (token) => {
    if (token === "GRID ERROR") {
        return "Your deal ID will be displayed here within 20 seconds. Please refresh your browser if it hasn't appeared after 20 seconds."
    }
    return token;
}

export const getGreenColor = (isGreen = false) => isGreen ? "#93C969" : "#D5D5D5"

export const getSortByOptions = () => [
    {
        "label": "Name: A - Z",
        "value": "0",
    },
    {
        "label": "Name: Z - A",
        "value": "1",
    },
    {
        "label": "Date Created: A - Z",
        "value": "2",
    },
    {
        "label": "Date Created: Z - A",
        "value": "3",
    },
    {
        "label": "Date Modified: A - Z",
        "value": "4",
    },
    {
        "label": "Date Modified: Z - A",
        "value": "5",
    }
]
export const getSuperFormatOptions = () => [
    { label: "Premium", value: "Premium"},
    { label: "Advanced", value: "Advanced"},
    { label: "Pro-Skin Desktop", value: "Pro-Skin Desktop"},
    { label: "Pro-Skin Mobile", value: "Pro-Skin Mobile"},
    { label: "Airtime", value: "Airtime"}
]
export const getSortConfigurations = (sortBy, alter = false) => {
    let sortConfigurations = {
        0: { property: 'ad_name', direction: 'ASC' },
        1: { property: 'ad_name', direction: 'DESC' },
        2: { property: 'createAt', direction: 'ASC' },
        3: { property: 'createAt', direction: 'DESC' },
        4: { property: 'updateAt', direction: 'ASC' },
        5: { property: 'updateAt', direction: 'DESC' },
    };
    if(alter){
        sortConfigurations = {
            0: { property: 'ad_name', direction: 'ASC' },
            1: { property: 'ad_name', direction: 'DESC' },
            2: { property: 'created_on', direction: 'ASC' },
            3: { property: 'created_on', direction: 'DESC' },
            4: { property: 'updated_on', direction: 'ASC' },
            5: { property: 'updated_on', direction: 'DESC' },
        };
    }
    let sorted = sortConfigurations[Number(sortBy)]
    return  sorted ? [sorted] : alter ? [{ property: 'created_on', direction: 'DESC' }] : [{ property: 'createAt', direction: 'DESC' }]
}

export const isFormatDiscount = (val) => {
    if(!val) return false
    let name = val.toLowerCase()
    return !name.includes("pro-skin") && !name.includes("airtime")
}
export const isAirtimeCreative = (ad) => {
    return ad?.ad_type === "Airtime" ? true : false
}

export const hasAttentionArc = (addons) => {
    let hasArc = false;
    if(addons?.length){
        for(let i = 0 ; i < addons.length; i++){
            if(addons[i].name.toLowerCase() === "attentionarc" || addons[i].name.toLowerCase() === "al alpha" || addons[i].name.toLowerCase() === "ai alpha"){
                hasArc = true
            }
        }
    }
    return hasArc;

}

export const isAUNZAccount = (account) => {
    if(account?.countryCode === "AU" || account?.countryCode === "NZ" || account === "AU" || account === "NZ"){
        return true
    }
    return false
}


export const getIntricacyLevel = (dealType) => {
    if (dealType?.name === "Premium") {
        return 8
    }
    else if (dealType?.name === "Lite") {
        return 4
    }
    else {
        return 14
    }
}
export const getCategorizedData = (array, field = "provider") => {
    return array.reduce((result, item) => {
      // If company doesn't exist in the result object, create an array
      if (!result[item[field]]) result[item[field]] = [];
      
      result[item[field]].push(item);
      return result;
    }, {});
  }
  export const getCategorizedDataMediumRare = (array, selected = []) => {
  // Pull out the names in the exact order you care about
  const orderedNames = selected.map(s => s.name);

  // Build the final list by walking through orderedNames
  // and grabbing all items whose provider matches each name
  const info = orderedNames.reduce((acc, name) => {
    const matches = array.filter(item => item.provider === name);
    return acc.concat(matches);
  }, []);

  return { info };
};
export const getCategorizedDataJSON = (array, field = "dataProvider", fieldName = "provider") => {
    return array.reduce((acc, item) => {
        const name = JSON.parse(item[field])[fieldName];

        if (!acc[name]) acc[name] = [];
        acc[name].push(item);
        return acc;
      }, {});
}
export const downloadAssetZIP = async (creatives, dealName) => {
    const zip = new JSZip();

    const downloadPromises = creatives.map(async (cre) => {
        let assets = cre["content"][0]["imageSrc"], name = cre.ad_name
        
        try {
            const response = await axios.get(assets, { responseType: "blob" });

            // Ensure the name is safe and has an extension
            const hasExt = /\.[a-z0-9]+$/i.test(name);
            const ext = response.headers['content-type']?.split("/")[1] || "bin";
            const safeName = (hasExt ? name : `${name}.${ext}`).replace(/[^a-z0-9_.()-]/gi, "_");

            zip.file(safeName, response.data);
        } catch (err) {
            console.error("Failed to fetch:", assets, err);
        }
    });

    await Promise.all(downloadPromises);
    const blob = await zip.generateAsync({ type: "blob" });
    const safeTitle = dealName.replace(/[^a-z0-9_\- ]/gi, "_");
    saveAs(blob, `${safeTitle} assets.zip`);
};
export const isDemoDeal = (id) => (id === config.DEMO_DEAL_ID || id === config.DEMO_DEAL_CO2_ID || id === config.DEMO_DEAL_DOOH_ID)

export const mediaText = (isDOOH = false, isMedium = false) => {
    if(!isDOOH && (config.commbank || isMedium)) return "Audience"
    return isDOOH ? "Targeting" : "Media"
}
export const isDOOH = (c) => {
    return (c === "Digital OOH" || c === "In-Branch" || c === "In-store") ? true : false
}
export const isMediumRareFormat = (c) => {
    return config.mediumrare && (c === "On-site" || c === "Direct channel" || c === "In-store") ? true : false
}

export const isInstreamVideo = (c) => {
    return c === "Instream Video" ? true : false
}
export const isVOD = (c) => {
    return c === "VOD" ? true : false
}